import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class CurrencyUnit extends EntityDto implements IEntityDto {
    CurrencyUnit_Id: string;
    CurrencyUnitName: string; 
    CurrencyUnitCode: string; 
    Currency_Id: string;
    CurrencyName: string;
    TotalCount: number;
    IsActive: boolean;
    
    constructor() {
        super();
        this.CurrencyUnit_Id = "00000000-0000-0000-0000-000000000000";
        this.CurrencyUnitName = "";
        this.CurrencyUnitCode = "";
        this.Currency_Id = "";
        this.CurrencyName = ""; 
        this.TotalCount = 0; 
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'CurrencyUnitCode', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            
            { FieldName: 'CurrencyUnitName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Currency Unit Name is required' },
            //{ FieldName: 'Currency_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Currency is required' },
        ];
    }
}
